import Immutable from 'immutable';

const Session = Immutable.Record({
  id: null,
  type: 'Unknown',
  name: 'Unknown',
  preview: 'No preview available',
  createdAt: null,
  lastSeenAt: 0,
  trackingId: null,
  messages: Immutable.OrderedSet(),
  lockedAt: null,
  queueId: '',
  satisfactionId: null,
  satisfactionStatus: null,
  satisfactionLockedAt: null,
  satisfactionSubmittedAt: null,
});

export default Session;
